import React from 'react'
import {LinkComponent, SocialComponent} from '../utils/links'
import {AiOutlineClose} from 'react-icons/ai'
import {useGlobalContext} from '../context'

function Sidebar() {
    const {closeSidebar, isSidebarOpen} = useGlobalContext();
    return (
        <aside className={"sidebar" + (isSidebarOpen ? " open" : "")}>
            <div className="sidebar-button-close">
                <AiOutlineClose className="social-icon button-open" onClick={closeSidebar}/>
            </div>
            <LinkComponent classStyle="nav-sidebar"/>
            <SocialComponent classStyle="social-sidebar"/>
        </aside>
    )
}

export default Sidebar
